define('models/AdvantageGroupModel',['underscore', 'app', 'ObjectModel', 'models/AdvantageCollection', 'models/AdvantageModel'],
    function (_, app, ObjectModel, AdvantageCollection,AdvantageModel) {
        //
        // AdvantageGroupModel
        //
        var _FILTERS_ID_ = _(AdvantageModel._FILTERS_);

        var AdvantageGroupModel = ObjectModel.extend({
            initialize: function () {
                var model = this,
                    filters = [],
                    advantagesCollection;

                //
                // setup Advantage Collection
                //
                advantagesCollection = new AdvantageCollection(model.get('advantages'),{group:model});
                model.advantagesCollection = advantagesCollection;
                //
                // setup filters
                //
                advantagesCollection.each(function(advantage){
                    _FILTERS_ID_.each(function(filterId){
                        if(advantage.get(filterId) && !_(filters).contains(filterId)){
                            filters.push(filterId);
                        }
                    });
                });
                model.set('filters',filters);
            },
            getFilters:function(){
                return this.get('filters');
            },
            getFiltersClassList:function(){
                return _(this.getFilters()).map(function(f){ return 'filter-'+f; }).join(' ');
            },
            getAdvantages:function(){
                return this.advantagesCollection;
            },
            getUsableAdvantages:function(onCart){
                return this.advantagesCollection.getUsableAdvantages(onCart);
            }
        });

        return AdvantageGroupModel;

    });
